import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "stock/product-departments";

export const GET_STOCK_PRODUCT_DEPARTMENTS = "getStockProductDepartments";
export const GET_STOCK_PRODUCT_DEPARTMENT = "getStockProductDepartment";
export const GET_STOCK_PRODUCT_DEPARTMENT_OPTIONS = "getStockProductDepartmentOptions";
export const CREATE_STOCK_PRODUCT_DEPARTMENT = "createStockProductDepartment";
export const UPDATE_STOCK_PRODUCT_DEPARTMENT = "updateStockProductDepartment";
export const DELETE_STOCK_PRODUCT_DEPARTMENT = "deleteStockProductDepartment";

const actions = {
  [GET_STOCK_PRODUCT_DEPARTMENTS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PRODUCT_DEPARTMENT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_PRODUCT_DEPARTMENT_OPTIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/options`, params)
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_PRODUCT_DEPARTMENT](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_PRODUCT_DEPARTMENT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_PRODUCT_DEPARTMENT](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data ?? error));
    });
  },
};

export default {
  actions,
};
